/**
 * Push registration — deliberately inert on the web.
 *
 * The API's device-token endpoint validates `platform` as `oneof=iOS Android`
 * (services/api/internal/auth/dto.go) and dispatches through APNs/FCM. A
 * browser's Web Push subscription is a different credential shape delivered
 * over a different protocol, so registering one would need a backend change
 * (a `Web` platform value, VAPID keys, a web-push provider). This app adds
 * nothing to the backend, so it registers nothing.
 *
 * Nothing is lost from the fan's point of view except out-of-app delivery: the
 * notification records themselves are server-side, so the in-app notification
 * centre, the unread badge and notification preferences all work exactly as
 * they do on the phone.
 *
 * The module keeps mobile's exports and signatures so `authStore` and the
 * settings screen stay identical across the two apps.
 */

export type PushPermissionResult = 'granted' | 'denied' | 'unavailable';

/** Mobile branches on this to avoid touching expo-notifications in Expo Go.
 *  There is no such hazard here; it stays exported so shared code compiles. */
export const isExpoGo = false;

export async function requestPushPermission(): Promise<PushPermissionResult> {
  return 'unavailable';
}

/** No-op: see the module header. Never throws, so it cannot block sign-in. */
export async function registerPushToken(_accessToken: string): Promise<void> {
  /* intentionally empty */
}

/** No-op counterpart to `registerPushToken`. */
export async function unregisterPushToken(_accessToken: string): Promise<void> {
  /* intentionally empty */
}
